import { __ENV__ } from '@plco-pro/env'

import Analytics from './analytics'
import { AnalyticsEventType } from './analytics.types'

export default class ChannelTalk {
  constructor() {
    this.loadScript()
  }

  loadScript() {
    const w = window
    if (w.ChannelIO) {
      return (window.console.error || window.console.info || function () {})(
        'ChannelIO script included twice.',
      )
    }
    var ch = function () {
      ch.c(arguments)
    }
    ch.q = []
    ch.c = function (args) {
      ch.q.push(args)
    }
    w.ChannelIO = ch
    function l() {
      if (w.ChannelIOInitialized) {
        return
      }
      w.ChannelIOInitialized = true
      const s = document.createElement('script')
      s.type = 'text/javascript'
      s.async = true
      s.src = 'https://cdn.channel.io/plugin/ch-plugin-web.js'
      s.charset = 'UTF-8'
      const x = document.getElementsByTagName('script')[0]
      x.parentNode.insertBefore(s, x)
      // A workaround for license duplicate event (channel io doesn't support removing event listeners)
      w.ChannelIO('onShowMessenger', () => {
        Analytics.trackEvent(AnalyticsEventType.CHANNEL_TALK_CLICKED, {})
      })
    }
    if (document.readyState === 'complete') {
      l()
    } else if (window.attachEvent) {
      window.attachEvent('onload', l)
    } else {
      window.addEventListener('DOMContentLoaded', l, false)
      window.addEventListener('load', l, false)
    }
  }

  boot(settings, cb) {
    let config
    if (__ENV__ === 'production') {
      config = {
        ...require('@plco-pro-config/production.channel-talk.json'),
      }
    } else if (__ENV__ === 'stage') {
      config = {
        ...require('@plco-pro-config/stage.channel-talk.json'),
      }
    } else {
      config = {
        ...require('@plco-pro-config/development.channel-talk.json'),
      }
    }

    window.ChannelIO(
      'boot',
      {
        pluginKey: config.pluginKey,
        ...settings,
      },
      cb,
    )
  }

  updateUser(information, cb) {
    window.ChannelIO('updateUser', information, cb)
  }

  shutdown() {
    window.ChannelIO('shutdown')
  }

  showChannelButton() {
    window.ChannelIO('showChannelButton')
  }

  hideChannelButton() {
    window.ChannelIO('hideChannelButton')
  }

  showMessenger() {
    window.ChannelIO('showMessenger')
  }

  hideMessenger() {
    window.ChannelIO('hideMessenger')
  }

  track(eventName, eventProperty) {
    window.ChannelIO('track', eventName, eventProperty)
  }

  setPage(page) {
    window.ChannelIO('setPage', page)
  }

  onShowMessenger(callback) {
    window.ChannelIO('onShowMessenger', callback)
  }

  onHideMessenger(callback) {
    window.ChannelIO('onHideMessenger', callback)
  }
}
